import types from './mutation-types'
import ApiService from '@/service/api.service.js'
// asyncronous stuff happens here
// actions are dispatched from components : this.$store.dispatch('SOME_ACTION')
// actions do async stuff and 'commit' mutations

export const getUsersSearch = async ({ state, commit }, params) => {
  commit(types.FETCH_USERS, true)
  commit(types.UPDATE_PARAMS, params)
  try {
    const response = await ApiService.getUsersSearch(state.filterParams)
    commit(types.FETCH_USERS, false)
    commit(types.LOAD_USERS_DATA, response.data)
  } catch (error) {
    commit(types.FETCH_USERS, false)
    console.error(error)
  }
}

export const createNewUser = ({ commit }, payload) => {
  return ApiService.createUser(payload)
    .then((res) => {
      if (res.error) {
        return res
        // commit(types.CREATE_USER_FAILURE)
      } else {
        commit(types.LOAD_CREATEDUSER, res.data)
        return res
      }
    })
    .catch((err) => {
      console.error(err)
    })
}
